<template>
  <div class="app-footer">
    <div class="top-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <h2 class="footer-title">Address</h2>
            <p>
              Ad Pad Pvt. Ltd.
              Thapagaun, New Baneshwor
              Kathmandu
            </p>
          </div>
          <div class="col-md-3">
            <h2 class="footer-title">Social</h2>
            <ul>
              <li>
                <a href="https://www.facebook.com/AdPadPvtLtd">Facebook</a>
              </li>
            </ul>
          </div>
          <div class="col-md-3">
            <h2 class="footer-title">Call Us</h2>
            <ul>
              <li>+977-1-5244490 / 01-5244591</li>
            </ul>
          </div>
          <div class="col-md-3">
            <h2 class="footer-title">Our Email</h2>
            <ul>
              <li>adpad@gmail.com</li>
              <li>support@adpad.com.np</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-footer">
      <div class="container">
        <div class="row justify-content-between">
          <p>© 2019 ADPAD All Rights Reserved.</p>
          <p>Powered by ANS Soft Inc</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {};
</script>


<style scoped>
.top-footer {
  padding-top: 60px;
  border-top: 1px solid #e5e5e5;
}
ul {
  list-style: none;
  padding: 0;
}
.footer-title {
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: bold;
  color: #111;
}
a {
  color: #999;
}
.bottom-footer {
  background: #efefef;
  padding: 20px 0;
  margin-top: 60px;
  font-size: 12px;
  color: #666666;
  border-top: 1px solid #e5e5e5;
}
</style>